import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  Injector,
  Input,
  OnDestroy
} from '@angular/core';
import {InfoTooltipComponent} from './info-tooltip.component';

@Directive({
    selector: '[dbInfoTooltip]',
    standalone: false
})
export class InfoTooltipDirective implements OnDestroy {

  @Input('dbInfoTooltipPosition') position: 'top'|'top-right'|'bottom'|'left'|'right'|'dropdown'|'bottom-right'|'bottom-left'|'bottom-right-from-left'|'bottom-right-header'|'bottom-right-header-mobile'|'bottom-right-header-tools-mobile';
  @Input('dbInfoTooltipDelay') delay: number;
  @Input('premiumUpgrade') premiumUpgrade: boolean;
  @Input('dbInfoTooltipHeader') infoTooltipHeader: string;
  @Input('dbInfoTooltipClass') dbInfoTooltipClass: string;
  @Input('dbInfoTooltipBody') infoTooltipBody: string;
  @Input('dbInfoTooltipMoreInfo') infoTooltipMoreInfo: string;
  @Input('dbInfoTooltipMoreInfoLink') infoTooltipMoreInfoLink: string;
  @Input('dbInfoTooltipMoreInfoLinkText') infoTooltipMoreInfoLinkText: string;
  @Input('dbInfoTooltipCustomClass') dbInfoTooltipCustomClass?: string;
  private _dbInfoTooltipComponentRef: ComponentRef<InfoTooltipComponent>;
  private _mouseLeaveTimeout: any;

  constructor(
    private _element: ElementRef,
    private _applicationRef: ApplicationRef,
    private _injector: Injector,
    private _componentFactoryResolver: ComponentFactoryResolver
  ) {}

  @HostListener('click') onMouseOver() {
    this.showInfoTooltip();
  }

  private showInfoTooltip(): void {
    if (this._dbInfoTooltipComponentRef) {
      return;
    }
    if (localStorage.getItem("firstTimePageView") === null) {
      localStorage.setItem('firstTimePageView', "true");
    }

    // create a dropdown component reference
    this._dbInfoTooltipComponentRef = this._componentFactoryResolver.resolveComponentFactory(InfoTooltipComponent).create(this._injector);
    this._dbInfoTooltipComponentRef.instance.host = this._element.nativeElement;
    this._dbInfoTooltipComponentRef.instance.position = this.position || 'top';
    this._dbInfoTooltipComponentRef.instance.delay = this.delay;
    this._dbInfoTooltipComponentRef.instance.premiumUpgrade = this.premiumUpgrade;
    this._dbInfoTooltipComponentRef.instance.infoTooltipMoreInfo = this.infoTooltipMoreInfo;
    this._dbInfoTooltipComponentRef.instance.infoTooltipMoreInfoLink = this.infoTooltipMoreInfoLink;
    this._dbInfoTooltipComponentRef.instance.infoTooltipMoreInfoLinkText = this.infoTooltipMoreInfoLinkText;
    this._dbInfoTooltipComponentRef.instance.infoTooltipBody = this.infoTooltipBody;
    this._dbInfoTooltipComponentRef.instance.infoTooltipHeader = this.infoTooltipHeader;
    this._dbInfoTooltipComponentRef.instance.dbInfoTooltipClass = this.dbInfoTooltipClass;
    this._dbInfoTooltipComponentRef.instance.dbInfoTooltipCustomClass = this.dbInfoTooltipCustomClass;
    this._dbInfoTooltipComponentRef.instance.cancelHideEvent.subscribe(event => {
      if ( event === 'show' ) {
        clearTimeout(this._mouseLeaveTimeout);
      }
      else {
        this.hideInfoTooltip();
      }
    });
    // attach component to the applicationRef so that it will be dirty checked.
    this._applicationRef.attachView(this._dbInfoTooltipComponentRef.hostView);

    // get DOM element from component
    const infoTooltipComponentElement: HTMLElement = (this._dbInfoTooltipComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

    document.body.appendChild(infoTooltipComponentElement);
  }

  private hideInfoTooltip(): void {
    this._dbInfoTooltipComponentRef && this._dbInfoTooltipComponentRef.destroy();
    this._dbInfoTooltipComponentRef = null;
  }

  @HostListener('mouseleave') mouseleave() {
    this._mouseLeaveTimeout = setTimeout((): void => {
      this.hideInfoTooltip();
    }, 0 );
  }

  ngOnDestroy() {
    this.hideInfoTooltip();
  }

}
